import {
    useDeleteTodoMutation,
    useSelectColorToggleMutation,
    useToggleSelectedMutation,
    useUpdateTodoMutation,
} from "../features/todo/api/todoApi";
import cancel from "./../assets/images/cancel.png";
import { useState } from "react";
import { FiEdit } from "react-icons/fi";

export const Todo = ({ todo }) => {
    const { id, text, completed, color } = todo;
    const [apiDeleteTodo] = useDeleteTodoMutation();
    const [toggleColorApi] = useSelectColorToggleMutation();
    const [toggleSelectedApi] = useToggleSelectedMutation();
    const [updateTodoApi] = useUpdateTodoMutation();
    const [isEdit, setIsEdit] = useState(false);
    const [editText, setEditText] = useState(text);

    // delete todo
    const deleteHandler = () => {
        apiDeleteTodo(id);
    };

    // color toggle
    const toggleColor = (color) => {
        toggleColorApi({ id, color });
    };

    // complete task
    const isCompletedHandler = () => {
        toggleSelectedApi({ id, isCompleted: !completed });
    };

    // edit handler
    const editHandler = () => {
        setIsEdit(!isEdit);
    };

    // update handler
    const updateHandeler = (e) => {
        e.preventDefault();

        updateTodoApi({ id, editText });
        setIsEdit(false);
    };

    return (
        <>
            <div className="flex justify-start items-center p-2 hover:bg-gray-100 hover:transition-all space-x-4 border-b border-gray-400/20 last:border-0">
                <div
                    onClick={isCompletedHandler}
                    className={`rounded-full bg-white border-2 border-gray-400 w-5 h-5 flex flex-shrink-0 justify-center items-center mr-2  ${
                        completed && "border-green-500"
                    }`}
                >
                    <input
                        type="checkbox"
                        className="opacity-0 absolute rounded-full"
                    />
                    {completed && (
                        <svg
                            className="fill-current w-3 h-3 text-green-500 pointer-events-none"
                            viewBox="0 0 20 20"
                        >
                            <path d="M0 11l2-2 5 5L18 3l2 2L7 18z" />
                        </svg>
                    )}
                </div>

                <div className="select-none flex-1">
                    {isEdit ? (
                        <form onSubmit={updateHandeler}>
                            <input
                                type="text"
                                placeholder="Type..."
                                className="h-10 px-4 border rounded focus:outline-none"
                                value={editText}
                                required
                                onChange={(e) => setEditText(e.target.value)}
                            />
                        </form>
                    ) : (
                        text
                    )}
                </div>

                <div
                    onClick={() => toggleColor("green")}
                    className={`flex-shrink-0 h-4 w-4 rounded-full border-2 ml-auto cursor-pointer border-green-500 hover:bg-green-500 ${
                        color === "green" && "bg-green-500"
                    }`}
                ></div>

                <div
                    onClick={() => toggleColor("yellow")}
                    className={`flex-shrink-0 h-4 w-4 rounded-full border-2 ml-auto cursor-pointer border-yellow-500 hover:bg-yellow-500 ${
                        color === "yellow" && "bg-yellow-500"
                    }`}
                ></div>

                <div
                    onClick={() => toggleColor("red")}
                    className={`flex-shrink-0 h-4 w-4 rounded-full border-2 ml-auto cursor-pointer border-red-500 hover:bg-red-500 ${
                        color === "red" && "bg-red-500"
                    }`}
                ></div>

                <button
                    onClick={editHandler}
                    className="text-[16px] text-blue-600"
                >
                    <FiEdit />
                </button>

                <img
                    src={cancel}
                    className="flex-shrink-0 w-4 h-4 ml-2 cursor-pointer"
                    alt="Cancel"
                    onClick={deleteHandler}
                />
            </div>
        </>
    );
};
